import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { RawMaterialDto } from 'src/app/shared/dto/rawMaterial.dto';
import { SourceEnum } from 'src/app/shared/enums/source.enum';
import { BaseService } from 'src/app/shared/services/base.service';
import { FinalProductDto } from './../../shared/dto/final-product.dto';

@Injectable({
    providedIn: 'root'
})
export class FinalProductService extends BaseService {
    // private readonly finalProductsSubject = new BehaviorSubject<FinalProductDto[]>([]);
    // public finalProducts$ = this.finalProductsSubject.asObservable();

    // private readonly socketService = inject(SocketService);
    constructor(httpClient: HttpClient) {
        super(httpClient, 'final-products');
    }
    // async setupWebSocket(): Promise<void> {
    //     try {
    //         this.finalProductsSubject.next((await this.findAll()).finalProducts);
    //         this.socketService.conectSocketRoom(formatClientRoom(Client.DEFAULT_CLIENT, RoomNames.FINAL_PRODUCTS_ROOM));
    //         this.socketService.getNotifications(Messages.FINAL_PRODUCTS_CHANGED).subscribe(async () => {
    //             const response = await this.findAll();
    //             this.finalProductsSubject.next(response.finalProducts);
    //         });
    //     } catch (e: any) {
    //         throw new Error(`Error al establecer conexión con el socket de Productos Finales. Error: ${e.message}`);
    //     }
    // }

    // disconnectWebSocket(): void {
    //     this.socketService.disconnectSocketRoom(formatClientRoom(Client.DEFAULT_CLIENT, RoomNames.FINAL_PRODUCTS_ROOM));
    // }

    // async findAll(): Promise<FinalProductResponseDto> {
    //     try {
    //         const request = this.httpClient.get<FinalProductResponseDto>(`${this.url}/findAll`);

    //         const response: FinalProductResponseDto = await lastValueFrom(request);

    //         return response;
    //     } catch (e: any) {
    //         throw new Error(`No se ha encontrado ningun producto final. Error: ${e.message}`);
    //     }
    // }

    // async createFinalProduct(finalProduct: FinalProductDto): Promise<FinalProductDto> {
    //     try {
    //         const request = this.httpClient.post<CustomerDto>(`${this.url}/create`, finalProduct);

    //         const createdFinalProduct: FinalProductDto = await lastValueFrom(request);

    //         return createdFinalProduct;

    //     } catch (e: any) {
    //         throw new Error(`No se ha podido crear el producto final. Error: ${e.error.message}`);
    //     }
    // }

    // async updateFinalProduct(finalProduct: FinalProductDto): Promise<FinalProductDto> {
    //     try {
    //         const request = this.httpClient.put<FinalProductDto>(`${this.url}/update`, finalProduct);

    //         const updatedFinalProduct: FinalProductDto = await lastValueFrom(request);

    //         return updatedFinalProduct;

    //     } catch (e: any) {
    //         throw new Error(`No se ha podido actualizar el producto final. Error: ${e.message}`);
    //     }
    // }

    // async deleteFinalProduct(finalProductId: number): Promise<FinalProductDto> {
    //     try {
    //         const request = this.httpClient.delete<FinalProductDto>(`${this.url}/delete/${finalProductId}`);

    //         const response: FinalProductDto = await lastValueFrom(request);

    //         if (!response) {
    //             throw null;
    //         }

    //         return response;
    //     } catch (e: any) {
    //         throw new Error(`No se ha podido eliminar el producto final ${finalProductId}. Error: ${e.message}`);
    //     }
    // }

    async updateRawMaterialQuantityFromFinalProduct(rawMaterial: RawMaterialDto): Promise<RawMaterialDto> {
        try {
            const request = this.httpClient.patch<RawMaterialDto>(`${this.url}/updateRawMaterialQuantityFromFinalProduct`, {rawMaterial});

            return await lastValueFrom(request);
        } catch (error: any) {
            throw new Error(`No se ha podido modificar la materia prima del producto final. Error: ${error.message}`);
        }
    }

    async updateManyQuantityProduced(finalProductsToUpdate: {id: number, quantityProduced: number}[]): Promise<FinalProductDto[]> {
        try {
            if(finalProductsToUpdate.some(fp => fp.quantityProduced! < 0)){
                throw new Error(`La cantidad producida no puede ser negativa`);
            }

            if(finalProductsToUpdate.some(fp => fp.id! <= 0)){
                throw new Error(`El id del producto final ha de ser mayor de 0`);
            }

            const request = this.httpClient.post<FinalProductDto[]>(`${this.url}/updateManyQuantityProduced`, { finalProducts: finalProductsToUpdate });

            return await lastValueFrom(request);
        } catch (error: any) {
            throw new Error(`No se ha podido actualizar la cantidad producida. Error: ${error.message}`);
        }
    }

    async setFinalProductsToOrderProcess(productionOrderProcessId: number, finalProducts: FinalProductDto[]): Promise<FinalProductDto[]> {
        try {
            if(productionOrderProcessId <= 0){
                throw new Error(`El id del proceso de orden de producción ha de ser mayor de 0`);
            }

            const request = this.httpClient.patch<FinalProductDto[]>(`${this.url}/setFinalProductsToOrderProcess/${productionOrderProcessId}`, {finalProducts});

            return await lastValueFrom(request);
        } catch (error: any) {
            throw new Error(`No se han podido asignar los productos finales. Error: ${error.message}`);
        }
    }

    async removePackagingFromFinalProduct(finalProductId: number, packagingId: number): Promise<void> {
        try {
            if(finalProductId <= 0 || packagingId <= 0){
                throw new Error(`El id del producto final o del formato ha de ser mayor de 0`);
            }

            const request = this.httpClient.delete<void>(`${this.url}/removePackagingFromFinalProduct/${finalProductId}/${packagingId}`);

            return await lastValueFrom(request);
        } catch (error: any) {
            throw new Error(`No se ha podido eliminar el formato del producto final. Error: ${error.message}`);
        }
    }

    async getRawMaterialsByFinalProduct(finalProductId: number): Promise<RawMaterialDto[]> {
        try {
            if(!finalProductId ){
                throw new Error(`El id del producto final ha de ser mayor de 0`);
            }

            const request = this.httpClient.get<RawMaterialDto[]>(`${this.url}/getRawMaterialsByFinalProduct/${finalProductId}`);

            return await lastValueFrom(request);
        } catch (error: any) {
            throw new Error(`No se han podido obtener las materias primas del producto final. Error: ${error.message}`);
        }
    }

    async getRawMaterialsByFinalProductAndPackaging(finalProductId?: number, packagingId?: number): Promise<RawMaterialDto[]> {
        try {
            if(!finalProductId && !packagingId){
                throw new Error(`El id del producto final o del formato ha de ser mayor de 0`);
            }

            const request = this.httpClient.get<RawMaterialDto[]>(`${this.url}/getRawMaterialsByFinalProductAndPackaging/${finalProductId}/${packagingId}`);

            return await lastValueFrom(request);
        } catch (error: any) {
            throw new Error(`No se han podido obtener las materias primas del formato. Error: ${error.message}`);
        }
    }

    async addRawMaterialsToFinalProductsOrPackagings(rawMaterials: RawMaterialDto[], finalProductIds: number[], source: SourceEnum, packagingIds?: number[], orderProcessId?: number): Promise<FinalProductDto[]> {
        try {
            const request = this.httpClient.post<FinalProductDto[]>(`${this.url}/addRawMaterialsToFinalProductsOrPackagings`, { finalProductIds: finalProductIds, packagingIds: packagingIds, rawMaterials: rawMaterials, orderProcessId: orderProcessId, source });

            return await lastValueFrom(request);
        } catch (error: any) {
            throw new Error(`No se han podido agregar las materia primas los productos finales o formatos. Error: ${error.message}`);
        }
    }

    async updateStock(finalProducts: FinalProductDto[]): Promise<void> {
        try {
            const request = this.httpClient.post<void>(`${this.url}/updateStock`, { finalProducts: finalProducts });

            return await lastValueFrom(request);
        } catch (error: any) {
            throw new Error(`No se han actualizar los stocks de los productos. Error: ${error.message}`);
        }
    }
}
